import React, { useEffect } from "react"
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import { Auth } from 'app'

import { HeaderLayout } from "component/Layout"
import { NotFoundPage, AccessDeniedPage, LoadingPage } from 'page/Error'
import { IndexPage, AboutPage, CoursesPage, ContactPage, CreditsPage, TermsPage } from 'page/Index'
import { AdminHomePage } from 'page/Admin'
import { UserHomePage } from 'page/User'
import { CoursePage, ResourcePage, TestsessionPage } from 'page/Course'

const ScrollToTop = () => {
    const { pathname } = useLocation()
    useEffect(() => {
      window.scrollTo(0, 0)
    }, [pathname])
  
    return null
}

const TitleSetter = (props) => {
    useEffect(() => {
        if (props.title){
            document.title = `${props.title} | Sohani Academy`
        } else {
            document.title = `Sohani Academy`
        }
    }, [props.title])
    return props.children
}

const ProtectedRoute = (props) => {    
    const role = Auth.useGetRole()
    const hasRole = Auth.useCheckRole(props.role)
    const userEmail = Auth.useGetEmail() // as a unique key to detect auth changes
    if(!role) {
        return <LoadingPage />
    } else if (!hasRole){
        return <AccessDeniedPage />
    } else {
        return <React.Fragment key={userEmail}>
            { props.children }
        </React.Fragment>
    }
}

export class Router {
    static routes = {
        INDEX:          { path: '/',                                title: 'Home',          component: IndexPage,       role: 'ROLE_ANON' },
        USER_HOME:      { path: '/user',                            title: 'User Home',     component: UserHomePage,    role: 'ROLE_USER' },
        ADMIN_HOME:     { path: '/admin',                           title: 'Admin Home',    component: AdminHomePage,   role: 'ROLE_ADMIN'},
        CREDITS:        { path: '/credits',                         title: 'Credits',       component: CreditsPage,     role: 'ROLE_ANON' },
        TERMS:          { path: '/terms',                           title: 'Terms',         component: TermsPage,       role: 'ROLE_ANON' },
        COURSE_VIEW:    { path: '/course/:course_name',             title: 'Course',        component: CoursePage,      role: 'ROLE_ANON' },
        RESOURCE_VIEW:  { path: '/resource/:course_name/:resIdx',   title: 'Resource',      component: ResourcePage,    role: 'ROLE_ANON' },
        TESTSESSION:    { path: '/testsession/:handle',             title: 'Testsession',   component: TestsessionPage, role: 'ROLE_ANON' },
    }
    
    static RouterMap = () => {
        var allRoutes = []
        for (const [key, node] of Object.entries(Router.routes)){
            allRoutes.push(<Route exact={true} key={key} path={node.path} element={
                <TitleSetter title={node.title} >
                    <ProtectedRoute role={node.role} >
                        {React.createElement(node.component)}
                    </ProtectedRoute>
                </TitleSetter>
            } />)
        }
        return <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HeaderLayout />}>
                    { allRoutes }
                    <Route path="*" element={<NotFoundPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    }
}
